import { PageKeyMap, PageLoadedSelectorsMap } from '@/telemetry-sdk';

const pageKeyMap: PageKeyMap = {
  homepage: '/',
  // include only CLP
  browse_cat: /^\/(health|beauty|personal-care|home-electronics|electronics|baby-and-child)$/,
  browse_plp: /\/c\//,
};

const pageLoadedSelectorsMap: PageLoadedSelectorsMap = {
  homepage: ['[data-testid="masthead-main-bar"]', '.banner-container', '[data-testid="menu-tile-image"]'],
  browse_cat: ['.chakra-heading'],
  browse_plp: ['.chakra-checkbox', '[data-testid="checkbox"]', '.chakra-heading'],
};

export { pageKeyMap, pageLoadedSelectorsMap };
